import React from "react";

/**
 * React Error Boundary - catches render errors and shows fallback UI.
 * Prevents the entire app from crashing on uncaught component errors.
 */
class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const err = this.state.error;
      const showDetails = process.env.NODE_ENV === "development";
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            textAlign: "center",
            fontFamily: "system-ui, sans-serif",
          }}
        >
          <h1 style={{ fontSize: "1.5rem", marginBottom: 12, color: "#333" }}>
            Oups, une erreur s'est produite
          </h1>
          <p style={{ color: "#666", marginBottom: 24, maxWidth: 400 }}>
            Rechargez la page pour réessayer.
          </p>
          {showDetails && err ? (
            <pre
              style={{
                textAlign: "left",
                maxWidth: "min(720px, 100%)",
                marginBottom: 24,
                padding: 12,
                fontSize: 12,
                lineHeight: 1.45,
                color: "#991b1b",
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 8,
                overflow: "auto",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {err.stack || err.message || String(err)}
            </pre>
          ) : null}
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 20px",
              fontSize: 16,
              backgroundColor: "#2563eb",
              color: "white",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            Recharger la page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
